<template>
  <div class="user-container">
    <div class="table-field">
      <el-row>
        <label style="margin:0 30px;">收费单位:</label>
        <el-select v-model="params.companyId" placeholder="请选择">
          <el-option v-for="item in companyArry" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
        </el-select>
        <el-button style="margin:0 30px;" type="primary" @click="handleSearch">搜索</el-button>
        <el-button class type="primary" @click="dialogFormVisible = true">新增</el-button>
      </el-row>
    </div>
    <el-table
      :data="tableData"
      :row-style="{height:'30px'}"
      :cell-style="{padding:'5px 0'}"
      style="width: 100%"
      height="580px"
      :border="true"
      :header-cell-style="{background: '#f2f2f2'}"
    >
      <el-table-column prop="name" label="类型名称"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
    </el-table>
    <el-dialog title="新增收费类型" :width="`450px`" :visible.sync="dialogFormVisible">
      <el-form :model="payTypeDTO">
        <el-form-item label="收费单位">
          <el-select v-model="payTypeDTO.companyId" placeholder="请选择">
            <el-option v-for="item in companyArry" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :model="payTypeDTO">
        <el-form-item label="收费类型名称">
          <el-input v-model="payTypeDTO.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddPayType">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { payTypeList, addPayType, companyList } from "@/axios/api";
export default {
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      payTypeDTO:{
          name: '',
          companyId: ''
      },
      params: {
        companyId: ''
      },
      companyArry: []
    };
  },
  methods: {
      handleSearch() {
        this.getPayTypeList();
      },
      handleCompanyList() {
          companyList().then(res => {
            if (res.status === 200) {
              this.companyArry = res.data || []
            }
          })
      },
      handleAddPayType(){
          this.dialogFormVisible = false
          addPayType(this.payTypeDTO).then(res => {
              if(res.status === 200){
                  this.$message.success("保存成功");
                  this.getPayTypeList();
              }else{
                  this.$message.error(res.msg);
              }
          })
      },
    getPayTypeList() {
      payTypeList(this.params).then(res => {
        this.tableData = res.data;
        this.total = res.total;
      });
    }
  },
  mounted() {
    this.handleCompanyList()
    this.getPayTypeList();
  }
};
</script>

<style scoped>
.table-field .el-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.table-field {
  width: 100%;
  height: 60px;
  border: 1px solid #ebebeb;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.user-container {
  width: 100%;
  height: auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/pay/PayType.vue